import { combineReducers } from '@reduxjs/toolkit';

const reducer = combineReducers({});

export * from './order-api-slice';

export default reducer;
